import { get } from "@rails/request.js";
import debounce from "lodash/debounce";
import consumer from "./consumer"

window.addEventListener("turbo:load", function() {
  if (window.video_id) {
    const subscription = consumer.subscriptions.create({
      channel: "TranscodeChannel",
      video_id: window.video_id
    }, {
      rejected: () => {
        console.error("Transcode Status Subscription Rejected");
      },
      received: debounce((data) => {
        if (!data.trigger_refresh) {
          get(window.video_status_path, { responseKind: 'turbo-stream' });
        } else {
          window.location.reload(true);
        }
      }, 500, { leading: true, trailing: true })
    });

    const cleanup = () => {
      delete window.video_id;
      delete window.video_status_path;
      subscription.unsubscribe();
      window.removeEventListener("turbo:before-visit", cleanup);
    }

    window.addEventListener("turbo:before-visit", cleanup);
  }
});
